import { useEffect, useRef, useState } from "react";
import { MallangEngine } from "../engine/MallangEngine";

export default function MallangCanvas() {
  const ref = useRef<HTMLCanvasElement | null>(null);
  const eng = useRef<MallangEngine | null>(null);
  const [count, setCount] = useState(0);
  const [needSound, setNeedSound] = useState(false);
  const [failed, setFailed] = useState(false);
  const [needMotion, setNeedMotion] = useState(false);

  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const e = new MallangEngine(c, { onSquish: setCount, onAudioState: (r) => setNeedSound(!r), onMotionNeeded: setNeedMotion });
    eng.current = e;
    (window as Window & { __mallang?: MallangEngine }).__mallang = e; // debugging handle
    e.init().catch((err) => { console.error("말랑이 engine failed to start", err); setFailed(true); });
    return () => {
      e.dispose();
      eng.current = null;
      const w = window as Window & { __mallang?: MallangEngine };
      if (w.__mallang === e) delete w.__mallang;
    };
  }, []);

  return (
    <>
      <canvas ref={ref} className="fixed inset-0 z-[1] touch-none select-none" style={{ WebkitTouchCallout: "none" }} />
      <div className="pointer-events-none fixed bottom-5 left-5 z-[10] select-none text-sm font-semibold text-black/70">
        말랑 횟수 <span className="tabular-nums">{count}</span>
      </div>
      {failed && (
        <div className="pointer-events-none fixed inset-0 z-[5] flex items-center justify-center px-6 text-center text-sm font-semibold text-black/60">
          이 브라우저에서는 3D 그래픽(WebGL)을 쓸 수 없어서 말랑이를 띄우지 못했어요.
        </div>
      )}
      <div className="pointer-events-none fixed right-5 top-20 z-[10] flex flex-col items-end gap-2">
        {needSound && (
          <button
            type="button"
            onClick={() => eng.current?.unlockAudio()}
            className="pointer-events-auto cursor-pointer rounded-full bg-white/80 px-3 py-1 text-xs font-semibold shadow-md backdrop-blur"
          >
            소리 켜기
          </button>
        )}
        {needMotion && (
          // iPhone asks for motion access from a tap: tilting then makes it sag, shaking makes it wobble
          <button
            type="button"
            onClick={() => { eng.current?.unlockAudio(); void eng.current?.enableMotion(); }}
            className="pointer-events-auto cursor-pointer rounded-full bg-white/80 px-3 py-1 text-xs font-semibold shadow-md backdrop-blur"
          >
            흔들기 켜기
          </button>
        )}
      </div>
    </>
  );
}
